// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/notification/style/index.less
// module id = 1055
// module chunks = 1